export default "__VITE_ASSET__2427ab09__"